export default "__VITE_ASSET__CzNVKiC8__"